// Matomo tracking utility
declare global {
  interface Window {
    _paq: any[];
  }
}

export class MatomoTracker {
  private static instance: MatomoTracker;

  private constructor() {}

  public static getInstance(): MatomoTracker {
    if (!MatomoTracker.instance) {
      MatomoTracker.instance = new MatomoTracker();
    }
    return MatomoTracker.instance;
  }

  /**
   * Track a custom event in Matomo
   * @param category - Event category (e.g., 'ProductCard')
   * @param action - Event action (e.g., 'click', 'pin', 'unpin')
   * @param name - Event name (e.g., 'app-name')
   * @param value - Optional numeric value
   */
  public trackEvent(
    category: string,
    action: string,
    name?: string,
    value?: number
  ): void {
    if (typeof window !== 'undefined' && window._paq) {
      const eventData: (string | number)[] = [category, action];
      if (name) eventData.push(name);
      if (value !== undefined) eventData.push(value);

      window._paq.push(['trackEvent', ...eventData]);
    }
  }

  /**
   * Track a page view
   * @param customTitle - Optional custom page title
   * @param customUrl - Optional custom URL
   */
  public trackPageView(customTitle?: string, customUrl?: string): void {
    if (typeof window !== 'undefined' && window._paq) {
      if (customTitle && customUrl) {
        window._paq.push(['setCustomUrl', customUrl]);
        window._paq.push(['setDocumentTitle', customTitle]);
      }
      window._paq.push(['trackPageView']);
    }
  }

  /**
   * Track a goal conversion
   * @param goalId - Matomo goal ID
   * @param customRevenue - Optional custom revenue value
   */
  public trackGoal(goalId: number, customRevenue?: number): void {
    if (typeof window !== 'undefined' && window._paq) {
      if (customRevenue !== undefined) {
        window._paq.push(['trackGoal', goalId, customRevenue]);
      } else {
        window._paq.push(['trackGoal', goalId]);
      }
    }
  }

  /**
   * Set custom dimensions
   * @param dimensionId - Matomo dimension ID
   * @param value - Dimension value
   */
  public setCustomDimension(dimensionId: number, value: string): void {
    if (typeof window !== 'undefined' && window._paq) {
      window._paq.push(['setCustomDimension', dimensionId, value]);
    }
  }
}

// Export singleton instance
export const matomoTracker = MatomoTracker.getInstance();
